import { z } from "zod";

const SpeiDetailsSchema = z.object({
  clabe: z.string(),
  code: z.string(),
  order: z.string(),
});

type SpeiDetails = z.infer<typeof SpeiDetailsSchema>;

export { SpeiDetailsSchema, type SpeiDetails };
